import blog from "../../Assets/Projects/blog.png";

// WEBSITE
import Household from "../../Assets/Projects/website/Household1.png";
import Desabengkel from "../../Assets/Projects/website/Desabengkel1.jpeg";
import Pesona from "../../Assets/Projects/website/Pesona.png";
import Garuda from "../../Assets/Projects/website/Garuda.png";
import Laundry from "../../Assets/Projects/website/Laundry.png";
import ERP from "../../Assets/Projects/website/ERP.png";

// UI UX
import SC from "../../Assets/Projects/UI/Smartcity1.png";

// NLP
import Shoope from "../../Assets/Projects/NLP/Shoope.png";
import Glad2Glow from "../../Assets/Projects/NLP/G2g.png";
import Crypto from "../../Assets/Projects/NLP/Crypto.png";

// IOT
import Simantau from "../../Assets/Projects/IoT/Simantau1.png";
import Parkir from "../../Assets/Projects/IoT/parkir.png";

// MACHINE LEARNING
import Pakar from "../../Assets/Projects/ML/Pakar.png";
import Padi from "../../Assets/Projects/ML/Padi.png";

// Mobile
import Pedicare from "../../Assets/Projects/mobile/Pedicare.png";
import Absen from "../../Assets/Projects/mobile/Absen.png";
import Roster from "../../Assets/Projects/mobile/Roster.png";

// GIS
import Labucare from "../../Assets/Projects/GIS/Labucare.png";
import Scoring from "../../Assets/Projects/GIS/Scoring.png";

const projectData = [
  // ================= WEBSITE =================

  {
    id: 1,
    category: "website",
    title: "Household Management System",
    image: Household,
    description:
      "A web-based household sales management system developed during my MSIB internship at PT Telkomsel. The application streamlines sales data processing through interactive dashboards, automated ETL workflows, and centralized reporting, enabling efficient management of over 150,000 records while supporting faster and more accurate business decision-making.",
    github: "https://github.com/Rezaananda28",
    detail: "/projects/household",
  },
  {
    id: 13,
    category: "website",
    title: "Desa Bengkel Information System",
    image: Desabengkel,
    description:
      "A village information system developed to support digital transformation by providing public information services, promoting local MSMEs, and improving community engagement through a responsive web platform.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/desa-bengkel",
  },
  {
    id: 14,
    category: "website",
    title: "Rumah Laundry Management System",
    image: Laundry,
    description:
      "A web-based laundry management system designed to manage customers, service packages, transactions, and order tracking through an integrated and user-friendly platform.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/rumah-laundry",
  },
  {
    id: 17,
    category: "website",
    title: "ERP Point of Sale System",
    image: ERP,
    description:
      "A web-based ERP point of sale system that integrates sales transactions, inventory management, customer records, and business reporting into a centralized platform.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/erp-pos",
  },
  {
    id: 15,
    category: "website",
    title: "Pesona Wisata North Sumatra",
    image: Pesona,
    description:
      "A tourism information system that promotes destinations across North Sumatra by providing detailed attraction information, interactive maps, travel recommendations, and a responsive user experience.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/pesona-wisata",
  },
  {
    id: 16,
    category: "website",
    title: "Garuda Airlines Reservation System",
    image: Garuda,
    description:
      "A web-based airline reservation system that enables users to search flights, manage bookings, and streamline ticket reservation through an intuitive and responsive platform.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/garuda-airlines",
  },
  // ================= MOBILE =================

  {
    id: 2,
    category: "mobile",
    title: "PediCare (Patient Digital Care)",
    image: Pedicare,
    description:
      "A mobile healthcare application that helps parents monitor children's growth, manage health records, track immunization schedules, and access healthcare information through an intuitive and user-friendly interface.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/pedicare",
  },
  {
    id: 19,
    category: "mobile",
    title: "Smart Attendance System",
    image: Absen,
    description:
      "A mobile attendance management application that enables students to submit attendance online while allowing teachers to monitor, validate, and manage attendance records in real time.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/smart-attendance",
  },
  {
    id: 20,
    category: "mobile",
    title: "Smart Class Schedule System",
    image: Roster,
    description:
      "A mobile scheduling application that enables students to view daily class timetables while allowing teachers to access teaching schedules, assigned classrooms, and subjects through a centralized platform.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/smart-class-schedule",
  },

  // ================= UI UX =================

  {
    id: 3,
    category: "uiux",
    title: "Medan Smart City UI/UX Design",
    image: SC,
    description:
      "A modern Smart City UI/UX design created in Figma, featuring responsive web and mobile interfaces to improve digital public services, accessibility, and user experience for the Medan City Government.",
    github: "",
    detail: "/project/smart-city",
  },

  // ================= MACHINE LEARNING =================

  {
    id: 4,
    category: "ml",
    title: "Rice Production Priority Classification System",
    image: Padi,
    description:
      "A machine learning-based web application that classifies rice production priorities using the Random Forest algorithm. The system provides model training, evaluation, prediction, and interactive visualizations to support data-driven agricultural planning and improve decision-making based on production data.",
    github: "https://github.com/Rezaananda28/klasifikasi-produksi-padi-rf.git",
    detail: "/project/rice-production-priority",
  },
  {
    id: 11,
    category: "ml",
    title: "Honey Guava Disease Diagnosis Expert System",
    image: Pakar,
    description:
      "A web-based expert system that applies the Certainty Factor method to diagnose honey guava plant diseases based on observed symptoms and provide treatment recommendations for farmers.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/expert-system",
  },

  // ================= NLP =================

  {
    id: 5,
    category: "nlp",
    title: "Sentiment Analysis of SPayLater & SPinjam Reviews",
    image: Shoope,
    description:
      "A Natural Language Processing project that analyzes customer reviews of SPayLater and SPinjam services by classifying sentiments into positive, neutral, and negative categories using text preprocessing and machine learning techniques.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/sentiment-analysis-spaylater-spinjam",
  },
  {
    id: 8,
    category: "nlp",
    title: "Sentiment Analysis of Glad2Glow Reviews on TikTok Shop",
    image: Glad2Glow,
    description:
      "An NLP project that analyzes customer reviews of Glad2Glow products on TikTok Shop by classifying sentiments into positive, neutral, and negative categories using text preprocessing and machine learning techniques.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/glad2glow-sentiment-analysis",
  },
  {
    id: 9,
    category: "nlp",
    title: "Sentiment Analysis of Akademi Crypto Reviews",
    image: Crypto,
    description:
      "A Natural Language Processing project that analyzes customer reviews of Akademi Crypto using text preprocessing and machine learning techniques to classify sentiments into positive, neutral, and negative categories.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/crypto-academy-sentiment-analysis",
  },
  {
    id: 10,
    category: "nlp",
    title: "Sentiment Analysis of DANA Application Reviews",
    image: blog,
    description:
      "An NLP-based sentiment analysis system that classifies DANA application reviews from Google Play using TF-IDF and machine learning to identify user opinions and evaluate application performance.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/dana-sentiment",
  },

  // ================= GIS =================

  {
    id: 6,
    category: "gis",
    title: "Healthcare Route Optimization System",
    image: Labucare,
    description:
      "A Geographic Information System (GIS) that utilizes ArcGIS to identify the fastest routes to healthcare facilities in North Labuhanbatu, featuring interactive digital maps, route optimization, and healthcare location visualization.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/healthcare-route",
  },
  {
    id: 12,
    category: "gis",
    title:
      "GIS-Based Accessibility Analysis for Healthcare and Education Services",
    image: Scoring,
    description:
      "A GIS-based spatial analysis system that evaluates accessibility to healthcare and education services using a scoring method to support regional planning and public service decision-making.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/accessibility-analysis",
  },
  // ================= IOT =================

  {
    id: 7,
    category: "iot",
    title: "Simantau (Smart Agriculture Monitoring System)",
    image: Simantau,
    description:
      "An IoT-based smart agriculture monitoring system that collects real-time environmental data from multiple sensors and presents it through an interactive dashboard to support efficient agricultural monitoring and decision-making.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/simantau",
  },
  {
    id: 18,
    category: "iot",
    title: "Smart Parking System for Santiago Bernabéu Stadium",
    image: Parkir,
    description:
      "An IoT-based smart parking system that monitors parking availability in real time using sensors and provides an interactive dashboard to improve parking efficiency and reduce congestion.",
    github: "https://github.com/Rezaananda28",
    detail: "/project/smart-parking",
  },
];

export default projectData;
